import { useTranslation } from 'libs/i18n';
import { ROUTES } from 'libs/navigation';
import { Stack } from 'libs/ui';
import { Title } from 'modules/account/common/components';

import { SkeletonOrder } from '../../../order/components';
import {
  CreateOrderForm,
  CreateOrderFormProps,
  CreateOrderFormContent,
  CreateOrderFormFooter,
} from '../../component';
import { useCreateOrderContext } from '../../providers/OrderProvider';

import { ContentStyled } from './styles';

export interface CreateOrderViewProps extends CreateOrderFormProps {
  loading?: boolean;
  submitLoading?: boolean;
}

export const CreateOrderView = ({
  loading,
  submitLoading,
  ...formProps
}: CreateOrderViewProps) => {
  const { t } = useTranslation();
  const { orderType } = useCreateOrderContext();

  return (
    <ContentStyled>
      <Stack flex={1} spacing={32}>
        <Title
          backLink={ROUTES.account.orders.fullPath}
          title={t(`account.order.types.${orderType!}`)}
        />
        {loading ? (
          <SkeletonOrder />
        ) : (
          <CreateOrderForm {...formProps}>
            <CreateOrderFormContent />
            <CreateOrderFormFooter
              backLink={ROUTES.account.orders.fullPath}
              submitLabel={t('account.createOrder.submitLabel')}
              submitLoading={submitLoading}
            />
          </CreateOrderForm>
        )}
      </Stack>
    </ContentStyled>
  );
};
